export class Utente {
    id: number;
    RIDP: string;
    nome: string;
    cognome: string;
    idFornitore: number;
    tipologiaUtente: TipologiaUtente;
    nomeCompleto?: string;
}

export enum TipologiaUtente {
    ADMIN = 'ADMIN',
    ISPETTORE_ASSQUAL = 'ISPETTORE_ASSQUAL',
    FORNITORE= 'FORNITORE',
    UTENTE_ESTERNO = 'UTENTE_ESTERNO',
    UTENTE_INTERNO = 'UTENTE_INTERNO',
    PIAMAT = 'PIAMAT',
    RESPONSABILE_ASSQUAL= 'RESPONSABILE_ASSQUAL'
}


